import { createNode } from '@glueapp/graph-types';

export const RespondToApi = createNode({
    id: 'RespondToApi',
    name: 'Respond to API',
    description: 'Send a response back to an API request',
    category: 'API Server',
    color: '#808080',
    version: 1,
    inPorts: {
        'Status Code': { kind: 'number' },
        'Response Headers': {
            kind: 'array',
            subType: {
                kind: 'object',
                properties: { name: { kind: 'string' }, value: { kind: 'string' } },
                restriction: 'exact',
            },
        },
        'Response Body': { kind: 'object', properties: {}, restriction: 'open' },
    },
    optionalInPorts: ['Response Headers', 'Response Body'],
    outPorts: {},
    execute: input => {
        // @ts-expect-error - contexts not in createNode type
        const contexts = input.contexts as Record<string, unknown> | undefined;
        const apiEndpoint = contexts?.apiEndpoint as { requestId: string } | undefined;
        const requestId = apiEndpoint?.requestId;

        const statusCode = (input.inPorts['Status Code'] as number) ?? 200;
        const body = input.inPorts['Response Body'] ?? null;
        const headersList = input.inPorts['Response Headers'];

        const headers: Record<string, string> = {};
        if (Array.isArray(headersList)) {
            for (const header of headersList) {
                headers[header.name] = header.value;
            }
        }

        return {
            output: {},
            apiResponse: {
                requestId: requestId || '',
                statusCode,
                headers,
                body,
                streaming: false,
                isFinal: true,
            },
        };
    },
});
